import { createVanIconComponent } from "./van"

const Label = createVanIconComponent("label")
export default Label
